import { defaultsDeep } from 'lodash';
import axios, { AxiosRequestConfig } from 'axios';

export enum RequestMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
}

export default (options: AxiosRequestConfig): Promise<any> => {
  const defaultOptions: AxiosRequestConfig = {
    method: RequestMethod.Get,
  };

  const requestOptions: AxiosRequestConfig = defaultsDeep(options, defaultOptions);

  return new Promise((resolve, reject) =>
    axios.request(requestOptions)
      .then(resolve)
      .catch(reject));
};



// WEBPACK FOOTER //
// ./src/utilities/request/request.ts